import { CreditPurchaseSuccess } from "@pages/settings/subscription-settings/credits/credit-purchase-success";
import { NewCreditBadge } from "@pages/settings/subscription-settings/credits/new-credit-badge";

/** Renders new credit indication for example success dialog */
export function NewCreditIndication(): JSX.Element | null {
  return (
    <>
      <CreditPurchaseSuccess />
      <NewCreditBadge />
    </>
  );
}
